import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Heading } from '@common-fe/common-fe';

import AutoInvestmentBanner, { useAutoInvestmentBanner } from './AutoInvestmentBanner';

interface Props {
  accountId?: string;

  isRedesignMode?: boolean;
}
const AutoInvestmentStandaloneBanner: React.FC<Props> = ({ accountId, isRedesignMode }) => {
  const { t } = useTranslation();
  const { isDisplayedBanner } = useAutoInvestmentBanner();
  if (!isDisplayedBanner) {
    return null;
  }
  if (isRedesignMode) {
    return (
      <Box direction="column" margin={{ top: 'l' }} background="border1" round="moduleRound" pad="l">
        <AutoInvestmentBanner accountId={accountId} isWideMode />
      </Box>
    );
  }
  return (
    <Box
      direction="column"
      background="module"
      align="center"
      round="moduleRound"
      pad="l"
      margin={{ bottom: 'l' }}
    >
      <Box direction="row" justify="between" margin={{ bottom: 's' }}>
        <Heading color="blockTitle" level={4} size="16px">
          {t('Automatic Investments')}
        </Heading>
      </Box>

      <AutoInvestmentBanner accountId={accountId} isWideMode />
    </Box>
  );
};

export default AutoInvestmentStandaloneBanner;
